import React from "react";
import Table from "../../../core/pagination/datatable";

const OrderEvolution = ({ buildPurchaseOrderEvolutionTable }) => (
  <div className="table-responsive">
    <Table
      bordered
      size="small"
      pagination={false}
      columns={buildPurchaseOrderEvolutionTable().columns}
      dataSource={buildPurchaseOrderEvolutionTable().data}
    />
  </div>
);

export default OrderEvolution;
